import { Alert, Card, CardActionArea, CardContent, CircularProgress, LinearProgress, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { getMyLearningCoursesOptions } from '@drivingdoc/api-client/generated/react-query';

import { PageContainer } from 'components/PageContainer';

export default function MyCoursesPage() {
  const navigate = useNavigate();
  const courses = useQuery(getMyLearningCoursesOptions());
  return (
    <PageContainer title="My Courses">
      <Stack spacing={2}>
        {courses.isPending && <CircularProgress aria-label="Loading courses" sx={{ alignSelf: 'center' }} />}
        {courses.isError && (
          <Alert severity="error">Your online courses could not be loaded. Please refresh and try again.</Alert>
        )}
        {courses.data?.map((course) => (
          <Card key={course.courseId} variant="outlined">
            <CardActionArea onClick={() => navigate(`/student/courses/${course.courseId}`)}>
              <CardContent>
                <Typography variant="h6">{course.title}</Typography>
                <LinearProgress
                  variant="determinate"
                  value={course.progressPercent}
                  aria-label={`${course.title} completion`}
                  aria-valuetext={`${course.progressPercent}% complete`}
                  sx={{ my: 1 }}
                />
                <Typography color="text.secondary">
                  {course.completedAt ? 'Complete' : `${course.progressPercent}% complete`}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
        {courses.data?.length === 0 && <Typography color="text.secondary">No online courses available.</Typography>}
      </Stack>
    </PageContainer>
  );
}
